/*
 * Online-Widerrufsfunktion: schickt das Formular per fetch ans Automation-Tool und zeigt danach
 * die Eingangsmeldung mit Datum und Uhrzeit. Ohne JavaScript geht das Formular als normales POST
 * raus, das Automation-Tool antwortet dann mit einer eigenen Bestätigungsseite.
 */
(function () {
  'use strict';

  function show(container, textElement, text) {
    textElement.textContent = text;
    container.hidden = false;
  }

  function init(root) {
    var form = root.querySelector('[data-amq-widerruf-formular]');
    if (!form || form.dataset.amqWiderrufReady === '1') return;
    form.dataset.amqWiderrufReady = '1';

    // Mindest-Ausfüllzeit gegen Bots: das Automation-Tool verwirft alles, was schneller als 3 s kommt.
    form.elements.t.value = String(Date.now());

    // Link aus der Bestellmail: /pages/widerruf?order=%231001
    var order = new URLSearchParams(window.location.search).get('order');
    if (order && !form.elements.bestellnummer.value) {
      form.elements.bestellnummer.value = order.slice(0, 64);
      form.elements.bestellnummer.dispatchEvent(new Event('input', { bubbles: true }));
    }

    var success = root.querySelector('[data-amq-widerruf-erfolg]');
    var error = root.querySelector('[data-amq-widerruf-fehler]');
    var button = form.querySelector('[type="submit"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;

      error.hidden = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');

      fetch(form.action, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function (response) {
          return response.json().catch(function () { return null; }).then(function (data) {
            return { status: response.status, data: data };
          });
        })
        .then(function (result) {
          if (result.status === 200 && result.data && result.data.ok) {
            var text = form.dataset.textErfolg
              .replace('%EINGANG%', result.data.eingangText || '')
              .replace('%EMAIL%', form.elements.email.value.trim());
            show(success, success.querySelector('[data-amq-widerruf-erfolg-text]'), text);
            form.hidden = true;
            success.setAttribute('tabindex', '-1');
            success.focus();
            return;
          }
          var message = result.status === 429 ? form.dataset.textLimit : form.dataset.textFehler;
          show(error, error.querySelector('[data-amq-widerruf-fehler-text]'), message);
        })
        .catch(function () {
          show(error, error.querySelector('[data-amq-widerruf-fehler-text]'), form.dataset.textFehler);
        })
        .then(function () {
          button.disabled = false;
          form.removeAttribute('aria-busy');
        });
    });
  }

  function start() {
    document.querySelectorAll('[data-amq-widerruf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
